<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-toolbox"></i>Verify Action</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <p>Verify this action by providing your password.</p>
          <label class="sr-only">Password</label>
          <input
            type="password"
            [(ngModel)]="password"
            autocomplete="new-password"
            (keyup.enter)="verifyPassword()"
            placeholder="Password"
            class="form-control"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="close()">
      Cancel</button
    >&nbsp;
    <button type="button" class="btn btn-outline" (click)="verifyPassword()">
      Verify<i [ngClass]="{ 'fas fa-spinner fa-spin': busy }"></i>
    </button>
  </div>
</div>
